<template>
  <CCardBody>

    <CRow class="mb-4">
      <CCol class="col-6">
        <v-select
            @input="changeFactory"
            v-model="selected_factory"
            :options="user_factory_options"
            :name="`user_factory`"
            placeholder="Select Factory"
        >
        </v-select>
      </CCol>
      <CCol class="col-6">
        <search
            v-model="search"
            float='right'
            :clickHandler="searchSizes"
            placeholder="Type to search"
        />
        <b-button class="primary_button float-right mb-3" @click="addSize">Add Size</b-button>

      </CCol>
    </CRow>

    <b-table
        :items="sizes"
        :fields="headers"
        hover
        sorter
        show-empty
    >
    <template #cell(actions)="item">
      <edit  fillColor="#009FE3" @click="editSize(item)"></edit>
      <delete  fillColor="#009FE3" @click="deleteSize(item.item.id)"></delete>
    </template>
    </b-table>
    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
    ></b-pagination>
    <b-modal no-close-on-backdrop hide-footer id="modal-1" title="Add Container" @hidden="hideModal">
      <CRow>
        <CCol class="col-12">
          <label class="required">Size Name</label>
          <b-input v-validate="{required: true}" name="name" v-model="edit_size.name"></b-input>
          <div v-if="errors && errors.first('name')" class="error_msg">
            {{errors.first('name')}}
          </div>
          <label class="required">Size Code</label>
          <b-input v-validate="{required: true}" name="code" v-model="edit_size.code"></b-input>
          <div v-if="errors && errors.first('code')" class="error_msg">
            {{errors.first('code')}}
          </div>
          <b-button @click="addUpdateSize" class="mt-2 float-right" variant="primary">
            {{edit_size.id ? 'Update' : 'Save'}}
          </b-button>
        </CCol>
      </CRow>
    </b-modal>
  </CCardBody>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete.vue';
import Edit from 'vue-material-design-icons/Pencil.vue';
import { http } from "@/config/httpCommon"
export default {
  components: {
    Edit,
    Delete,
  },
  data(){
    return{
      id: 0,
      name: '',
      sizes: [],
      headers: [{key: 'label', label: 'Name'},{key: 'code', label: 'Code'}, {key: 'actions', label: 'Actions',}],
      base_url: process.env.VUE_APP_FILE_URL,
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      edit_size: {
        id: null,
        index: null,
        name: null,
        code: null
      },
      search: null,
      user_factory_options:[],
      selected_factory:null
    }
  },
  async created() {
    await this.$store.dispatch('getUserFactories')
    let user_factories = this.$store.getters.userFactoriesOptions;
    if(user_factories.length > 0){
      this.user_factory_options = user_factories;
      this.selected_factory = user_factories[0];
      let payload = '?factory_id='+this.selected_factory.value;
      this.getSizes(payload);
    }else{
      this.getSizes();
    }

  },
  methods: {
    searchSizes(search){
      let params = ''
      if(search) {
        params = '?search='+search;
      }
      if(this.selected_factory){
        params += (params == '') ? '?' : '&';
        params += 'factory_id='+this.selected_factory.value;
      }
      this.getSizes(params);
    },
    async getSizes(params=null) {
      let url = "sizes";
      if(params) {
        url += params
      }
      let res = await http.get(url);
      this.sizes = res.data.data;
      this.makePagination(res.data);
    },
    async handlePagination(page=''){
      let params = '?page='+page;
      if(this.search) {
        params += '&search='+this.search
      }
      if(this.selected_factory){
        params += '&factory_id='+this.selected_factory.value;
      }
      this.getSizes(params);
    },
    makePagination(pagination_data){
      this.pagination.currentPage = pagination_data.current_page;
      this.pagination.rows = pagination_data.total;
      this.pagination.perPage = pagination_data.per_page;
      this.pagination.total = pagination_data.total;
    },
    addSize() {
      this.$bvModal.show('modal-1');
    },
    async editSize(item){
      this.edit_size.id = item.item.id,
      this.edit_size.index = item.index,
      this.edit_size.name = item.item.label
      this.edit_size.code = item.item.code
      this.$bvModal.show('modal-1');
    },
    async addUpdateSize() {
      let valid = await this.$validator.validate();
      if(valid) {
        this.$store.commit('set', ['showLoader', true]);
        if(!this.selected_factory){
          this.showToast("Please select factory","Error");
          return false;
        }

       let size_data = {
         id: this.edit_size.id,
         name: this.edit_size.name,
         code: this.edit_size.code,
         factory_id: this.selected_factory.value
       };
       let url = "sizes";
       let action = this.edit_size.id ? "update" : "create";
       if(action == "update") {
         url += `/${this.edit_size.id}`;
         size_data["_method"] = "PUT"
       }

       let res = await http.post(url, size_data);
       let res_data = res.data;
       let result = res_data.result;
        if(res_data.success) {
          if(action == "update") {
            this.sizes[this.edit_size.index].label = result.size.name
            this.sizes[this.edit_size.index].code = result.size.code
          } else {
            let params = '?factory_id='+this.selected_factory.value;
            this.getSizes(params);
          }
          this.showToast(res_data.message, 'SUCCESS');
          this.$bvModal.hide('modal-1');
        } else {
          this.errors.add(res_data.errors);
        }
        this.$store.commit('set', ['showLoader', false]);
      }
    },
    changeFactory(obj){
      if(obj){
        let params = '?factory_id='+obj.value;
        if(this.search)
          params += '&search='+this.search;
        this.getSizes(params);
      }

    },
    async deleteSize(id){
      this.$store.commit('set', ['showLoader', true]);
      try {
        await http.delete(`sizes/${id}`);
        this.getSizes();
        this.showToast("Size Deleted", 'SUCCESS');
      }catch (err){
        this.showError(err);
      }
      this.$store.commit('set', ['showLoader', false]);
    },
    hideModal() {
      this.edit_size = {
        id: null,
        index: null,
        name: null,
        code: null,
      }
    }

  },
}
</script>
<style scoped>
.container_row{
  background-color: #dedede;
  padding: 10px 0;
  border-bottom: 1px solid #dede;
}
.files_row{
  padding: 10px 0;
  border-bottom: 1px solid #dddddd;
}
.actions{
  cursor: pointer;
}
.primary_button{
  background-color: #009FE3;
  color: #dddddd;
  margin: 10px 0 0 20px;
}
</style>